import { Map } from './map.class';
import './map.scss';

import '../../images/icons/global/pin.svg';

// Needs a special treatment because the mapsLoaded function is not able to access the same jQuery instance.
// Therefore it cannot be initialized with the component_handler.
export function map() {
    const className: string = 'map';

    const nodeList = Array.from(document.getElementsByClassName(className));
    const elements = [].slice.call(nodeList);

    if (elements.length > 0) {
        for (const element of elements) {
            const map = new Map(element);
            map.init();
        }

        loadMapsScript();
    }
}

function loadMapsScript() {
    if (!(window as any).googleMapsScriptLoaded) {
        const gmapKey = document.querySelector('.map__placeholder') as HTMLElement;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp' +
            '&key=' + gmapKey.dataset.gmapskey + '&callback=mapsLoaded';
        $('body').append(script);
        (window as any).googleMapsScriptLoaded = true;
    }
}

export function mapsLoaded() {
    const $elements: JQuery = $('.map');

    $elements.each((idx, element) => {
        const map: Map = $(element).data('self');
        map.onMapsScriptLoaded();
    });
}

// make mapsLoaded globally available to be called from google maps
(window as any).mapsLoaded = mapsLoaded;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/map/map.ts